<template>
  <nav id="sidebar" aria-label="Main Navigation" :style="{ background: '#fff', 'font-weight': 700 }">
    <slot>
      <!-- Side Header -->
      <div
        class="omc-header d-flex align-items-center justify-content-between"
        style="background: #fff; height: 80px; padding: 1em !important"
      >
        <!-- Logo -->
        <router-link :to="{ name: 'Main' }" variant="Main_Logo" class="mr-3 sidebar_logo">
          <!-- <img v-if="!isMobile" :src="`${$s3}/img/common/login/new_logo.svg?${$ver}`" /> -->
        </router-link>
        <!-- END Logo -->

        <!-- Extra -->
        <base-layout-modifier variant="alt-none" action="sidebarClose" class="p-0">
          <b-icon icon="x" scale="2" />
        </base-layout-modifier>
        <!-- END Extra -->
      </div>
      <!-- END Side Header -->

      <!-- Sidebar Scrolling -->
      <simplebar class="js-sidebar-scroll">
        <!-- Side Navigation -->
        <Menu class="side-bar" side-bar />
        <!-- END Side Navigation -->
      </simplebar>
      <!-- END Sidebar Scrolling -->
    </slot>
  </nav>
  <!-- END Sidebar -->
</template>

<script>
import { mapState, mapActions } from 'vuex';
import simplebar from 'simplebar-vue';

import Menu from '@/layouts/partials/Menus/Menu';

export default {
  name: 'BaseSidebar',
  components: {
    simplebar,
    Menu,
  },
  props: {
    classes: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      baseSearchTerm: '',
    };
  },
  computed: {
    ...mapState({
      isPhone: (state) => state.isPhone,
      isLogin: (state) => state.isLogin,
    }),
  },
  methods: {
    ...mapActions({
      getLogout: 'logout',
    }),
    logout() {
      this.getLogout().then(() => {
        this.$route.name !== 'Main' && this.$router.push({ name: 'Main' });
        this.$bvModal.show('logout');
      });
    },
    onSubmit() {
      //this.$router.push('/backend/pages/generic/search?' + this.baseSearchTerm)
    },
  },
};
</script>

<style lang="scss">
#beta-wrapper {
  position: relative;
  .beta {
    position: absolute;
    top: -2px;
    right: -33px;
    scale: 1.2;
  }
}
</style>
